import { Edit } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { Accessory, TempSensorValue, TEMP_SENSOR } from '@smart-home/common';
import { FC, useMemo } from 'react';
import Table, { Cell, Header } from 'components/Table';
import Temperature from 'components/Temperature';
import { useUpdateAccessory } from '../../hooks/useUpdateAccessory';
import { AccessoryProps } from '../accessories.types';
import { getValue } from '../accessories.utils';
import TempSensorAccessoryForm from './TempSensorAccessory.form';

const TempSensorAccessoryTable: FC<AccessoryProps> = ({ accessories, data }) => {
  const [[UpdateForm, updateFormProps], onUpdateAccessory] = useUpdateAccessory<Accessory>();
  const rows = useMemo(() => accessories.map(x => ({
    ...x,
    data: getValue<TempSensorValue>(TEMP_SENSOR, x.id, data),
  })), [accessories, data]);

  return (
    <>
      <Table
        grid="100px repeat(1, minmax(0, 1fr)) 80px 60px"
        data={rows}
        headers={<>
          <Header stiff>ALIAS</Header>
          <Header resize>TOPIC</Header>
          <Header>TEMP</Header>
          <Header />
        </>}
        row={({ row }) => (
          <>
            <Cell stiff>{row.alias}</Cell>
            <Cell>{`${row.topic}/${row.id}`}</Cell>
            <Cell><Temperature value={row.data} /></Cell>
            <Cell onClick={e => e.stopPropagation()}>
              <IconButton onClick={() => onUpdateAccessory({
                values: row,
              })}
              >
                <Edit fontSize="small" />
              </IconButton>
            </Cell>
          </>
        )}
      />
      <UpdateForm {...updateFormProps} formComponent={TempSensorAccessoryForm} />
    </>
  );
};

export default TempSensorAccessoryTable;
